const rePhoneNumber = /[+(]{0,2}?(?:\(\d+\))?[\d\s-]{5,25}\d/;

const phoneNumber = (text: string, pos: number) => {
  const tail = text.slice(pos - 1);
  if (!rePhoneNumber.test(tail)) return null;

  const result = tail.match(rePhoneNumber);
  if (!result) return null;

  const [match] = result;
  const numbersOnly = match.replaceAll(/[\s-)(]/g, '');
  if (numbersOnly.length < 9 || numbersOnly.length > 15) return null;

  return {
    matchedLength: match.trim().length - 1,
    match,
    tail,
  };
};

const phoneNumberValidator = (text: string, pos = 1) => {
  const hasPhoneNumber = phoneNumber(text, pos);
  if (!hasPhoneNumber) {
    return 0;
  }
  const { matchedLength, match, tail } = hasPhoneNumber;
  if (!tail?.startsWith(match)) return 0;
  return matchedLength;
};

const phoneNumbers = Array.from('+(0123456789', (prefix) => ({
  prefix,
  options: {
    validate: phoneNumberValidator,
    normalize(match: { url: string }) {
      // eslint-disable-next-line no-param-reassign
      match.url = `tel:${match.url.replaceAll(/[\s-)(]/g, '')}`;
    },
  },
}));

export { phoneNumber, phoneNumbers };
